export default __webpack_public_path__ + "static/media/brand-icon.591723c4.png";